import orderPrintDocumentsTemplate from '../templates/orderPrintDocuments.html';
function orderPrintDocumentsDirective() {
  return {
    restrict: 'AE',
    scope: {
      orderNumber: '<?',
      area: '<?',
      disabled: '<?',
      onlyWhenPaying: '<?',
      orderIsComplete: '<?'
    },
    bindToController: true,
    controller: 'OrderPrintDocumentsCtrl',
    controllerAs: 'orderPrintDocuments',
    templateUrl: orderPrintDocumentsTemplate
  };
}
export { orderPrintDocumentsDirective };